import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=a964d5de&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a964d5de')) {
      api.createRecord('a964d5de', component.options)
    } else {
      api.reload('a964d5de', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=a964d5de&", function () {
      api.rerender('a964d5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qT8cvzCv2rt0/JS/comp/ErrorMessage.vue"
export default component.exports